{
    "(save {highestYearlyDiscount}%)": "(spar {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dage gratis",
    "{amount} off": "{amount} rabat",
    "{amount} off for first {number} months.": "{amount} rabat for de første {number} måneder.",
    "{amount} off for first {period}.": "{amount} rabat for den/det første {period}.",
    "{amount} off forever.": "{amount} rabat for evigt",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% rabat",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} vil ikke længere modtage {newsletterName} nyhedsbrev.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} vil ikke længere modtage e-mails når nogen svarer på dine kommentarer.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} vil ikke længere modtage dette nyhedsbrev.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dage gratis",
    "{years} years": "",
    "+1 (123) 456-7890": "+45 12 34 56 78",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konto",
    "Account details updated successfully": "Kontooplysningerne blev opdateret",
    "Account settings": "Kontoindstillinger",
    "Add a personal note": "Tilføj en personlig note",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Når din gratis prøveperiode udløber, vil du blive opkrævet den normale pris for det abonnement du har valgt. Du kan selvfølgelig altid annullere dit abonnement inden.",
    "Already a member?": "Er du allerede medlem?",
    "An error occurred": "Der opstod en fejl",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Der opstod en uventet fejl. Prøv venligst igen eller <a>kontakt support</a> hvis fejlen fortsætter.",
    "Back": "Tilbage",
    "Back to Log in": "Tilbage til log ind",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Annuller når som helst.",
    "Cancel subscription": "Annuller abonnement",
    "Canceled": "",
    "Cancellation reason": "Årsag til annullering",
    "Change": "Skift",
    "Change plan": "Skift abonnement",
    "Check spam & promotions folders": "Tjek spam og kampagner mapper",
    "Check with your mail provider": "Tjek med din e-mailudbyder",
    "Check your inbox to verify email update": "Tjek din indbakke for at bekræfte e-mailopdateringen",
    "Choose": "Vælg",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Vælg et andet abonnement",
    "Choose a plan": "Vælg et abonnement",
    "Choose a tier": "",
    "Choose your newsletters": "Hvilke nyhedsbreve ønsker du",
    "Click here to retry": "Klik her for at prøve igen",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Luk",
    "Code": "",
    "Comment preferences updated.": "Kommentarpræferencer blev opdateret.",
    "Comments": "Kommentarer",
    "Complimentary": "Gratis",
    "Confirm": "Bekræft",
    "Confirm cancellation": "Bekræft annullering",
    "Confirm subscription": "Bekræft abonnement",
    "Contact support": "Kontakt support",
    "Continue": "Fortsæt",
    "Continue subscription": "Fortsæt tilmelding",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Kunne ikke oprette Stripe checkout-session",
    "Could not sign in. Login link expired.": "Kunne ikke log ind. Log ind link udløbet.",
    "Could not update email! Invalid link.": "Kunne ikke opdatere e-mail! Ugyldigt link.",
    "Create a new contact": "Opret ny kontakt",
    "Current plan": "Nuværende abonnement",
    "Delete account": "Slet konto",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Var det ikke dette du ønskede at gøre? Administrer dine præferencer <button>her</button>.",
    "Don't have an account?": "Har du ikke en konto?",
    "Edit": "Rediger",
    "Email": "E-mail",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "E-mail nyhedsbrev",
    "Email newsletter settings updated": "Indstillinger for nyhedsbrev blev opdateret",
    "Email preferences": "E-mail præferencer",
    "Email preferences updated.": "E-mailpræferencer blev opdateret.",
    "Emails": "E-mails",
    "Emails disabled": "E-mails deaktiveret",
    "Ends {offerEndDate}": "Udløber {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Indtast din e-mailadresse",
    "Enter your name": "Indtast dit navn",
    "Error": "Fejl",
    "Expires {expiryDate}": "Udløber {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Kunne ikke annullere abonnementet, prøv venligst igen",
    "Failed to log in, please try again": "Kunne ikke logge ind, prøv venligst igen",
    "Failed to log out, please try again": "Kunne ikke logge ud, prøv venligst igen",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Kunne ikke behandle betaling, prøv venligst igen",
    "Failed to send magic link email": "Kunne ikke sende magic link e-mail",
    "Failed to send verification email": "Kunne ikke sende bekræftelses-e-mail",
    "Failed to sign up, please try again": "Kunne ikke tilmelde dig, prøv venligst igen",
    "Failed to update account data": "Kunne ikke opdatere kontodata",
    "Failed to update account details": "Kunne ikke opdatere konto oplysninger",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Kunne ikke opdatere nyhedsbrev indstillinger, prøv venligst igen",
    "Failed to update subscription, please try again": "Kunne ikke opdatere abonnement, prøv venligst igen",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "For evigt",
    "Free Trial – Ends {trialEnd}": "Gratis prøveperiode - Udløber {trialEnd}",
    "From": "",
    "Get help": "Få hjælp",
    "Get in touch for help": "Tag kontakt for at få hjælp",
    "Get notified when someone replies to your comment": "Bliv notificeret når nogen svarer på din kommentar",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Giv feedback til dette indlæg",
    "Help! I'm not receiving emails": "Hjælp! Jeg modtager ikke e-mails",
    "Here are a few other sites you may enjoy.": "Her er et par andre sider du måske vil synes om.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Hvis et nyhedsbrev er markeret som spam, deaktiveres e-mails automatisk for den adresse så du ikke længere modtage uønskede beskeder.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Hvis spamklagen var utilsigtet, eller du gerne vil begynde at modtage e-mails igen, kan du abonnere igen på e-mails ved at klikke på knappen på det forrige skærmbillede.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Hvis du annullere dit abonnement nu, vil du fortsat have adgang indtil {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Hvis du har en virksomheds- eller statslig e-mailkonto, skal du kontakte din it-afdeling og bede dem om at tillade, at e-mails modtages fra {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Der er blevet sendt en link til din email, du kan bruge til at logge ind med. Hvis det ikke kommer frem indenfor 3 minutter, så tjek din spam mappe.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Hvis du gerne vil begynde at modtage e-mails igen, er de bedste næste trin at tjekke din registreret e-mailadresse for eventuelle problemer og derefter klikke på gentilmeld på den forrige skærmbillede.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Hvis du ikke modtager det e-mailnyhedsbrev, du har tilmeldt dig, er der et par ting, du skal tjekke.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Hvis du har gennemført alle disse checks, og du stadig ikke modtager e-mails, kan du kontakte {supportAddress} for at få hjælp.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "I tilfælde af, at der modtages en permanent fejl ved forsøg på at sende et nyhedsbrev, vil e-mails blive deaktiveret på kontoen.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Tilføj {senderEmail} til din kontaktliste i din e-mailklient. Dette signalerer til din e-mailudbyder, at e-mails sendt fra denne adresse skal være tillid til.",
    "Invalid email address": "Ugyldig e-mailadresse",
    "Invalid verification code": "",
    "Jamie Larson": "Sofie Nielsen",
    "jamie@example.com": "sofie@eksempel.dk",
    "Less like this": "Mindre af dette",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Sørg for, at e-mails ikke ender i Spam eller Kampagner mapper i din indbakke. Hvis de gør, skal du klikke på \"Markér som ikke spam\" og/eller \"Flyt til indbakke\".",
    "Manage": "Administrer",
    "Maybe later": "Måske senere",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Medlemskaber med dette domæne er i øjeblikket udelukket.",
    "Memberships unavailable, contact the owner for access.": "Medlemskaber er ikke tilgængelige. Kontakt ejeren for at få adgang.",
    "month": "måned",
    "Monthly": "Månedlig",
    "More like this": "Mere af dette",
    "More options": "",
    "Name": "Navn",
    "Need more help? Contact support": "Brug for hjælp? Kontakt support",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Nyhedsbreve kan deaktiveres på din konto af to årsager: En tidligere e-mail blev markeret som spam, eller forsøg på at sende en e-mail resulterede i en permanent fejl (bounce).",
    "No member exists with this e-mail address.": "Der findes ingen medlem med denne e-mailadresse.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Modtager du ikke e-mails?",
    "Now": "",
    "Now check your email!": "Tjek din e-mail!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Når du har tilmeldt dig igen, hvis du stadig ikke kan se e-mails i din indbakke, skal du tjekke din spam-mappe. Nogle e-mailudbydere registrerer tidligere spam-klager og vil blive ved med at markere e-mails. Hvis dette sker, skal du markere det seneste nyhedsbrev som 'Ikke spam' for at flytte det tilbage til din primære indbakke.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Permanent fejl (bounce)",
    "Phone number": "Telefonnummer",
    "Plan": "Abonnement",
    "Plan checkout was cancelled.": "Abonnementsbetaling blev annulleret.",
    "Plan upgrade was cancelled.": "Opgradering af abonnement blev annulleret.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Kontakt venligst {supportAddress} for at ændre dit gratis abonnement.",
    "Please enter {fieldName}": "Indtast venligst {fieldName}",
    "Please fill in required fields": "Udfyld venligst påkrævede felter",
    "Podcasts": "",
    "Re-enable emails": "Genaktiver e-mails",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Anbefalinger",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Bliver fornyet til {price}.",
    "Resume subscription": "",
    "Retry": "Prøv igen",
    "Save": "Gem",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Sender link til log ind",
    "Sending...": "Sender",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Vis alle",
    "Sign in": "Log ind",
    "Sign out": "Log ud",
    "Sign up": "Bliv medlem",
    "Signup error: Invalid link": "Tilmeldingsfejl: Ugyldigt link",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Noget gik galt, prøv venligst igen senere.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Beklager, der er ingen anbefalinger tilgængelige lige nu.",
    "Sorry, that didn’t work.": "Beklager, det virkede ikke.",
    "Spam complaints": "Spam klager",
    "Start {amount}-day free trial": "Start {amount}-dages gratis prøveperiode",
    "Starting {startDate}": "Fra {startDate}",
    "Starting today": "Fra i dag",
    "Submit feedback": "Send feedback",
    "Subscribe": "Tilmeld",
    "Subscribed": "Tilmeldt",
    "Subscription plan updated successfully": "Abonnementet blev opdateret",
    "Success": "Succes",
    "Success! Check your email for magic link to sign-in.": "Sådan! Tjek din indbakke for et magisk link til at logge ind.",
    "Success! Your account is fully activated, you now have access to all content.": "Sådan! Din konto er fuldt aktiveret, du har nu adgang til alt indhold.",
    "Success! Your email is updated.": "Sådan! Din e-mail er opdateret.",
    "Successfully unsubscribed": "Du er nu afmeldt",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Tak for din tilmelding. Før du begynder at læse, er her et par andre sider du måske vil synes om.",
    "Thank you for your support": "Tak for din støtte",
    "Thank you for your support!": "Tak for din støtte!",
    "Thanks for the feedback!": "Tak for din feedback!",
    "That didn't go to plan": "Det gik ikke helt efter planen",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Den e-mailadresse, vi har på dig, er {memberEmail} – hvis det ikke er korrekt, kan du opdatere den i dit <button>kontoindstillingsområde</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Der opstod et problem med at sende din feedback. Prøv venligst igen lidt senere.",
    "There was an error cancelling your subscription, please try again.": "Der opstod en fejl under annulleringen af dit abonnement, prøv venligst igen.",
    "There was an error continuing your subscription, please try again.": "Der opstod en fejl under forlængelsen af dit abonnement, prøv venligst igen.",
    "There was an error processing your payment. Please try again.": "Der opstod en fejl under behandlingen af din betaling. Prøv venligst igen.",
    "There was an error sending the email, please try again": "Der opstod en fejl under afsendelse af e-mailen, prøv venligst igen.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Denne sider kræver at du skal være inviteret. Kontakt ejeres for at få adgang.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Denne side accepterer ikke betalinger i øjeblikket.",
    "This site only accepts paid members.": "Denne side er kun tilgængelig for betalende medlemmer.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "For at gennemføre oprettelsen af din konto, skal du klikke på bekræftelseslinket i din e-mail indbakke. Hvis det ikke kommer indenfor 3 minutter, så tjek venligst din spam mappe!",
    "To continue to stay up to date, subscribe to {publication} below.": "For at fortsætte med at holde dig opdateret, skal du abonnere på {publication} nedenfor.",
    "Too many attempts try again in {number} days.": "For mange forsøg, prøv igen om {number} dage.",
    "Too many attempts try again in {number} hours.": "For mange forsøg, prøv igen om {number} timer.",
    "Too many attempts try again in {number} minutes.": "For mange forsøg, prøv igen om {number} minutter.",
    "Too many different sign-in attempts, try again in {number} days": "For mange forskellige loginforsøg, prøv igen om {number} dage.",
    "Too many different sign-in attempts, try again in {number} hours": "For mange forskellige loginforsøg, prøv igen om {number} timer.",
    "Too many different sign-in attempts, try again in {number} minutes": "For mange forskellige loginforsøg, prøv igen om {number} minutter.",
    "Too many sign-up attempts, try again later": "For mange tilmeldingsforsøg, prøv venligst igen senere",
    "Try free for {amount} days, then {originalPrice}.": "Prøv gratis i {amount} dage, derefter {originalPrice}.",
    "Unable to initiate checkout session": "Kan ikke starte betalings-session",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Lås op for adgang til alle nyhedsbreve ved at blive en betalingsabonnent.",
    "Unsubscribe from all emails": "Afmeld alle e-mails",
    "Unsubscribed": "Afmeldt",
    "Unsubscribed from all emails.": "Afmeldt fra alle emails.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Du annullerer ikke dit abonnement på {title} ved at afmelde dig fra alle e-mails",
    "Update": "Opdater",
    "Update your preferences": "Opdater dine præferencer",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Link til bekræftelse er sendt. Tjek din indbakke.",
    "Verify your email address is correct": "Tjek om din e-mailadresse er korrekt",
    "Verifying...": "",
    "View plans": "Se abonnementer",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Vi kunne ikke afmelde dig, da e-mailen ikke blev fundet. Kontakt venligst ejeren af siden.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Velkommen tilbage, {name}!",
    "Welcome back!": "Velkommen tilbage!",
    "Welcome to {siteTitle}": "Velkommen til {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Når en indbakke ikke accepterer en e-mail, kaldes det almindeligvis en bounce. I mange tilfælde kan dette være midlertidigt. Men i nogle tilfælde kan en afvist e-mail returneres som en permanent fejl, når en e-mailadresse er ugyldig eller ikke eksisterer.",
    "Why has my email been disabled?": "Hvorfor er min e-mail blevet deaktiveret?",
    "X (Twitter)": "",
    "year": "år",
    "Yearly": "Årlig",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Du har i øjeblikket et gratis medlemskab, opgrader til et betalt abonnement for fuld adgang.",
    "You have been successfully resubscribed": "Du er nu tilmeldt igen",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Du modtager ikke e-mails i øjeblikket",
    "You're not receiving emails": "Du modtager ikke e-mails",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Du modtager ikke e-mails fordi du enten har markeret en af de seneste mails som spam, eller fordi e-mails ikke kunne leveres til den oplyste e-mailadresse.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Du er nu logget ind.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Du er nu tilmeldt til <strong>{siteTitle}</strong>",
    "Your account": "Din konto",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Din e-mail kunne ikke genabonneres, prøv venligst igen.",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Dit input hjælper med at forme det der bliver publiceret.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Dit abonnement udløber {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Dit abonnement fornyes {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Dit abonnement starter {subscriptionStart}"
}
